import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const TOPICS_TOPIC_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/topics',
        iconClass: 'fas fa-list-alt',
        name: '::Menu:Topics',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Topics.Create && ReturnLy.Topics.Edit && ReturnLy.Topics.Delete',
        parentName: '::Menu:Configurations',
      },
    ]);
  };
}
